<template>
<!-- eslint-disable max-len -->
<div
  style="height: calc(100vh - 40px); color: var(--faqTextColor); background-color: var(--faqBackgroundColor);"
  class="help-center"
>
  <h1
    class="help-header"
  >
    Help Center
  </h1>
  <support-article-viewer
    style="margin: 25px 30px 16px;"
  ></support-article-viewer>
</div>
</template>

<script>
import SupportArticleViewer from '../ui/display/SupportArticleViewer';

export default {
  components: {
    SupportArticleViewer,
  },

  mounted() {
    console.log(this.$route);
  }
};
</script>

<style lang="scss" scoped>
.help-header {
  padding: 20px;
  font-size: 36px;
}

@media only screen and (max-height: 575.98px) and (orientation: landscape) {
  .help-header {
    padding: 2px 8px 0px;
    font-size: 21px;
  }
}

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  .help-header {
    padding: 2px 8px 0px;
    font-size: 21px;
  }

  // TODO: using this instead of app-wide system (setting on route) fails to resize and to rotate navbar with it
  // .help-center {
  //   transform: rotate(-90deg);
  //   transform-origin: left top;
  //   width: calc(var(--detected-viewport-height) / 1.1);
  //   height: 97vw;
  //   overflow-x: visible;
  //   position: absolute;
  //   top: calc(var(--detected-viewport-height) / 1.05);
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/support/HelpCenter.vue